import { useQuery } from '@tanstack/react-query';
import { parse } from 'query-string';
import { useContext, useEffect } from 'react';
import { giftcardState } from '../client-state/giftcard-state-context';
import { loadGiftcardMinimalShops } from './data-loaders/shops-loader';
import { selecetedShopIdActionTypes } from '../../../redusers/selected-shop-id-reducer';

const useGiftcardMinimalShops = () => {
  const { state, dispatch } = useContext(giftcardState);
  const params = parse(window.location.search);

  let city: string | undefined = undefined;
  if (typeof params.city === 'string') {
    city = params.city;
  }

  let country: string | undefined = undefined;
  if (typeof params.country === 'string') {
    country = /great britain/i.test(params.country) ? 'United Kingdom' : params.country;
  }

  const query = useQuery({
    queryKey: ['giftcardMinimalShops', city, country],
    queryFn: () => loadGiftcardMinimalShops(city, country),
    // Only load minimal shops if no shopId param is present
    enabled: Boolean(typeof params.shopId !== 'string'),
  });

  useEffect(() => {
    if (!state.selectedShopId && query.data && query.data.length > 0 && params.selected) {
      // Match params.selected on both shop name and shop id
      const minimalShop = query.data.find(
        (foundShop) =>
          foundShop.name === params.selected || foundShop.id === params.selected
      );

      if (minimalShop) {
        console.log('setting shop id from params.selected');
        dispatch({
          type: selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE,
          payload: minimalShop.id,
        });
      }
    }
  }, [dispatch, params.selected, query.data, state.selectedShopId]);

  return query;
};

export default useGiftcardMinimalShops;
